import React from "react";
import styles from "./FeaturesSection.module.css";
import Frame1 from "../../Assets/1.png";
import Frame2 from "../../Assets/2.png";
import Frame3 from "../../Assets/3.png";
import Line from "../../Assets/Vector1.png";
const FeaturesSection = () => {
  return (
    <section className={styles.featuresSection}>
      <div className={styles.container}>
        {/* Feature 1 */}
          <div className={styles.Line}>
                        <h2>Features</h2>
                         <div className={styles.divi}> </div>
              </div>
        <div className={styles.feature}>
          <div className={styles.featureImage}>
            <img src={Frame1} />
          </div>
          <div className={styles.featureText}>
            <h3>News</h3>
                  <img src={Line}/>
            <p>
              Read short news updates across multiple categories. Each news is presented in a crisp, easy-to-read format so you can stay informed in under a minute.
            </p>
          </div>
        </div>

        {/* Feature 2 */}
      <div className={`${styles.feature} ${styles.featureReverse}`}>
          <div className={styles.featureText}>
            <h3>Video</h3>
                 <img src={Line}/>  
            <p>
             Watch the latest viral and news videos — quick, engaging, and relevant. From global headlines to local updates, everything is just a scroll away.
            </p>
          </div>
          <div className={styles.featureImage}>
            <img src={Frame2} alt="Directory" />
          </div>
        </div>

        {/* Feature 3 */}
        <div className={styles.feature}>
          <div className={styles.featureImage}>
            <img src={Frame3} alt="Know Your Leader" />
          </div>
          <div className={styles.featureText}>
            <h3>Trending</h3>
              <img src={Line}/>
            <p>
             Find out what’s making waves across regions. Stay ahead with the most talked-about news of the day.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
